<div class="map-container">
  <!-- Mode sélection actif -->
  <div class="selection-mode" *ngIf="isSelectingStart || isSelectingEnd">
    <button 
      class="cancel-button"
      (click)="cancelSelection()"
    >
      <i class="fas fa-times"></i>
      {{ isSelectingStart ? ('cancel_start_selection' | translate) : ('cancel_destination_selection' | translate) }}
    </button>
  </div>

  <!-- Inputs normaux -->
  <div *ngIf="!isSelectingStart && !isSelectingEnd" class="flex flex-col sm:flex-row gap-5 mx-auto" style="position: absolute;top: 0px; width: 100%;background: none;z-index: 1000;padding: 0px 30px;padding-top: 40px;">

    <!-- Start Location Input -->
    <div class="relative  flex flex-row gap-0 input-map  my-auto mx-auto" >
      <label  class="block  m-auto   " style="padding-left: 10px;">
        {{ 'COMMON.FROM' | translate }}
      </label>
      <div class="relative flex-1" >
        <!-- Input field -->
        <input
          #startInput
          [formControl]="startControl"
          type="text"
          [placeholder]="('enter_departure_point' | translate)"
          (input)="onStartInputChange($event)"
          class=" input-map w-full rounded-lg border-transparent px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        <!-- Icon inside left -->
          <!-- <div class="marker-icon start-marker">
          <span class="material-symbols-outlined">location_on</span>
          </div> -->
          <span class="material-icons material-symbols-outlined absolute left-3 top-3 text-blue-500">
           {{ "from" | translate }}
          </span>

        <!-- Icon button with tooltip on right -->
        <button
          class=" absolute right-0 top-0 p-0 rounded-full    " style="width: 30px;background: white;height:40px;"
          [title]="('select_on_map' | translate)"
          (click)="startSelection()"
        >
          <img src="icons/location.svg" [alt]="('my_location' | translate)" class="w-40" style="margin-right: 0px;width: 20px!important;">
        </button>

        <!-- Predictions -->
        <div *ngIf="startPredictions.length > 0"
          class="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-auto">
          <div *ngFor="let prediction of startPredictions"
            class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            (click)="selectStartLocation(prediction)">
            {{ prediction.description }}
          </div>
        </div>
      </div>
    </div>

    <!-- End Location Input -->
    <div class="relative  flex flex-row gap-0 input-map  my-auto mx-auto" >
      <label class="block  m-auto " style="padding-left: 10px;">
        {{ 'COMMON.TO' | translate }}
      </label>
      <div class="relative flex-1">
        <!-- Input field -->
        <input
          #endInput
          [formControl]="endControl"
          type="text"
          [placeholder]="('enter_destination' | translate)"
          (input)="onEndInputChange($event)"
          class=" input-map w-full rounded-lg border-transparent px-3 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
        

        <!-- Icon button with tooltip on right -->
        <button
          class="absolute right-0 top-0 p-0 rounded-full  text-blue-600 " style="width: 30px;background: white;height:40px"
          [title]="('select_on_map' | translate)"
          (click)="endSelection()"
        >
          <img src="icons/location.svg" [alt]="('my_location' | translate)" width="40px" style="width: 20px!important;">
        </button>

        <!-- Predictions -->
        <div *ngIf="endPredictions.length > 0"
          class="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-auto">
          <div *ngFor="let prediction of endPredictions"
            class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            (click)="selectEndLocation(prediction)">
            {{ prediction.description }}
          </div>
        </div>
      </div>
    </div>

  </div>



  <!-- Map -->
  <google-map 
    #mapRef
    [center]="center"
    [zoom]="zoom"
    [options]="options"
    (mapClick)="onMapInitialized($event)"
    height="100%"
    width="100%"
    
  >
    <!-- Departure Marker -->
    <ng-container *ngIf="departMarker">
      <map-advanced-marker 
        *ngIf="useAdvancedMarkers && departPriceTag" 
        [position]="departMarker.position" 
        [content]="departPriceTag" 
      />
      <map-marker
        *ngIf="!useAdvancedMarkers"
        [position]="departMarker.position"
        [title]="departMarker.title || ''"
        [options]="departMarker.options || {}"
      >
      </map-marker>
    </ng-container>

    <!-- Selected Location Marker -->
    <ng-container *ngIf="selectedMarker">
      <map-advanced-marker 
        *ngIf="useAdvancedMarkers && destinationPriceTag" 
        [position]="selectedMarker.position"  
        [content]="destinationPriceTag" 
      />
      <map-marker
        *ngIf="!useAdvancedMarkers"
        [position]="selectedMarker.position"
        [title]="selectedMarker.title || ''"
        [options]="selectedMarker.options || {}"
      >
      </map-marker>
    </ng-container>

  </google-map>
</div>

